import React from 'react';
import HeroSection3 from './HeroSection3';
import PropertyTypes from './PropertyTypes';
import PopularDeals from './PopularDeals';
import AboutUs from './AboutUs';
import Counter from './Counter';
import Testimonial from './Testimonial';
import FeaturedProperties from './FeaturedProperties';
import Cta from './Cta';
import Footer from '../Layout/Footer';
import PropertyBookModal from './PropertyBookModal';

export default function Home3() {
  return (
    <>
      <HeroSection3/>
      <PropertyTypes/>
      <PopularDeals/>
      <AboutUs/>
      <Counter/>
      <Testimonial/>
      <FeaturedProperties/>
      <Cta/>
      <Footer/>
      <PropertyBookModal/>
    </>
  )
}
